export const SupplyChainRoles = [
  "Supplier",
  "Subsidiary",
  "Affliate",
  "PartnerShip/JV",
  "Franchises",
  "Independent",
  "Node",
  "Site",
  "Station",
  "Facility",
  "Center",
  "Depot",
  "Equity Share",
  "Operational Control",
  "Financial Control",
];
export const SupplyChainLevels = ["Product-level", "Project-level", "Facility-level"];
